import React, { createContext, Fragment, useMemo, type PropsWithChildren } from 'react';
import { functionWithFG, componentWithFG } from '@atlaskit/platform-feature-flags-react';

type UserAccess = {
	accountId?: string;
	isUserAnonymous: boolean;
}

type Props = PropsWithChildren & {
	accountId?: string;
}

const createUserAccessContext = () => createContext<UserAccess>(undefined!);
const createNoopContext = () => createContext<UserAccess>({ accountId: undefined, isUserAnonymous: false });

export const UserAccessContext = functionWithFG(
	'forge-ui-allow-anon-rest-calls',
	createUserAccessContext,
	createNoopContext
)();

const UserAccessProviderImpl = ({ accountId, children }: Props) => {
	const value = useMemo(() => {
		return {
			accountId,

			// Determine whether a user is anonymously accessing the Forge app UI.
			// Future: enhance to incorporate product account types, and Forge
			// decoupled licensing logic.
			get isUserAnonymous() {
				return !accountId;
			}
		}
	}, [accountId]);

	return (
		<UserAccessContext.Provider value={value}>
			{ children }
		</UserAccessContext.Provider>
	)
}

export const UserAccessProvider = componentWithFG(
	'forge-ui-allow-anon-rest-calls',
	UserAccessProviderImpl,
	Fragment
)
